/**
 * FILE: assets/zme-mega-menu.js
 *
 * Add to theme.liquid just before </body>:
 *   {{ 'zme-mega-menu.js' | asset_url | script_tag }}
 *
 * Handles:
 *   • Mobile hamburger → open / close drawer
 *   • Accordion toggles inside the mobile drawer
 *   • Close drawer on ESC key
 *   • Trap focus inside open drawer (accessibility)
 */

(function () {
  'use strict';

  /* ── Elements ── */
  const toggle  = document.querySelector('.zme-header__mobile-toggle');
  const drawer  = document.getElementById('zme-mobile-drawer');
  const body    = document.body;

  if (!toggle || !drawer) return;

  /* ── Open / close helpers ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    body.style.overflow = 'hidden';
    // swap hamburger → close icon
    toggle.innerHTML = `
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">
        <line x1="1" y1="1" x2="17" y2="17"/>
        <line x1="17" y1="1" x2="1" y2="17"/>
      </svg>`;
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    body.style.overflow = '';
    // restore hamburger icon
    toggle.innerHTML = `
      <svg width="22" height="16" viewBox="0 0 22 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <line x1="1" y1="2" x2="21" y2="2"/>
        <line x1="1" y1="8" x2="21" y2="8"/>
        <line x1="1" y1="14" x2="21" y2="14"/>
      </svg>`;
  }

  /* ── Hamburger click ── */
  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  /* ── ESC key closes drawer ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
      toggle.focus();
    }
  });

  /* ── Accordion toggles inside drawer ── */
  const accordionBtns = drawer.querySelectorAll('.zme-drawer__toggle');

  accordionBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const sub      = btn.nextElementSibling;          // .zme-drawer__sub
      const isOpen   = btn.getAttribute('aria-expanded') === 'true';

      /* Close all other open panels */
      accordionBtns.forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          const otherSub = other.nextElementSibling;
          if (otherSub) otherSub.classList.remove('is-open');
        }
      });

      /* Toggle current */
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        sub.classList.remove('is-open');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        sub.classList.add('is-open');
      }
    });
  });

  /* ── Desktop: announce mega menu open to screen readers ── */
  const megaItems = document.querySelectorAll('.zme-header__nav-item--mega');

  megaItems.forEach(function (item) {
    const link    = item.querySelector('.zme-header__nav-link');
    const wrapper = item.querySelector('.zme-header__mega-wrapper');

    if (!link || !wrapper) return;

    item.addEventListener('mouseenter', function () {
      link.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      link.setAttribute('aria-expanded', 'false');
    });

    /* Keyboard: open on Enter/Space, close on Escape */
    link.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = link.getAttribute('aria-expanded') === 'true';
        link.setAttribute('aria-expanded', String(!expanded));
        if (!expanded) {
          /* Focus first link inside mega */
          const firstLink = wrapper.querySelector('a');
          if (firstLink) firstLink.focus();
        }
      }
      if (e.key === 'Escape') {
        link.setAttribute('aria-expanded', 'false');
        link.focus();
      }
    });
  });

})();
